module.exports = [{"type":"title","text":"2024-12-17"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual U-Margin: Hedge Mode Supports Automatic Margin Addition"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-12-17.json
// module id = DOPU
// module chunks = 3